<p-popover appPopoverArrow #panel appendTo="body" styleClass="package-popover">
  <div class="packages">
    <div class="packages__heading">Packages:</div>

    @for (package of packages; track package; let i = $index) {
      <div class="package">
        <div class="package__fields">
          @if (!package.isValid()) {
            <div class="package__index">
              <span
                [pTooltip]="
                  isPtlQuote()
                    ? 'please specify package weight, length and width'
                    : 'please specify package dimensions or CBM and weight'
                "
                tooltipPosition="right"
                class="validation--error"
              >
                <i class="pi pi-exclamation-circle"></i>
              </span>
            </div>
          }
          <div class="package__field">
            <div class="package__label">Weight ({{ weightUnit }}):</div>
            <div class="package__control">
              <input
                pInputText
                [disabled]="disabled()"
                type="number"
                step="0.1"
                [(ngModel)]="package.weightInUnit"
                (keyup)="updateMetersFromCentimeters(package)"
                class="form-control"
              />
            </div>
          </div>
          <div class="package__field">
            <div class="package__label">Length ({{ measurementUnit }}):</div>
            <div class="package__control">
              <input
                pInputText
                [disabled]="disabled()"
                type="number"
                step="0.1"
                [(ngModel)]="package.lengthInUnit"
                (keyup)="
                  updateMetersFromCentimeters(package);
                  updateLdmAndMeasurement(package)
                "
                class="form-control"
              />
            </div>
          </div>
          <div class="package__field">
            <div class="package__label">Width ({{ measurementUnit }}):</div>
            <div class="package__control">
              <input
                pInputText
                [disabled]="disabled()"
                type="number"
                step="0.1"
                [(ngModel)]="package.widthInUnit"
                (keyup)="
                  updateMetersFromCentimeters(package);
                  updateLdmAndMeasurement(package)
                "
                class="form-control"
              />
            </div>
          </div>
          <div class="package__field">
            <div class="package__label">Height ({{ measurementUnit }}):</div>
            <div class="package__control">
              <input
                pInputText
                [disabled]="disabled()"
                type="number"
                step="0.1"
                [(ngModel)]="package.heightInUnit"
                (keyup)="
                  updateMetersFromCentimeters(package);
                  updateLdmAndMeasurement(package);
                  updateStackable(package)
                "
                class="form-control"
              />
            </div>
          </div>
          <div class="package__field">
            <div class="package__label">Quantity:</div>
            <div class="package__control">
              <input
                pInputText
                [disabled]="disabled()"
                type="number"
                step="1"
                min="1"
                [(ngModel)]="package.quantity"
                (keyup)="updateLdmAndMeasurement(package)"
                class="form-control"
              />
            </div>
          </div>
          <div class="package__field">
            <div class="package__label">{{ cubicUnit }}:</div>
            <div class="package__control">
              <input
                pInputText
                type="number"
                step="0.1"
                disabled="disabled"
                [value]="getMeasurementInUnit(package.getMeasurement())"
                class="form-control"
              />
            </div>
          </div>
          @if (showLdm()) {
            <div class="package__field">
              <div class="package__label">LDM:</div>
              <div class="package__control">
                <input
                  pInputText
                  type="number"
                  step="0.1"
                  disabled="disabled"
                  [value]="package.getLdm()"
                  class="form-control"
                />
              </div>
            </div>
          }
        </div>

        <div class="package__footer">
          <div class="package__options">
            @if (showPallets()) {
              <div class="package__option">
                <p-checkbox
                  [disabled]="disabled()"
                  class="package__chkbox"
                  [ngModel]="package.pallet"
                  (onChange)="package.setPallet($event.checked)"
                  binary="true"
                >
                </p-checkbox>
                <span class="package__option-label">Pallet</span>
              </div>
            }
            <div class="package__option">
              @if (package.quantity !== 1) {
                <p-checkbox
                  [disabled]="
                    disabled() ||
                    package.stackableDisabled ||
                    !package.heightInUnit
                  "
                  class="package__chkbox"
                  [ngModel]="package.stackable"
                  (onChange)="
                    package.setStackable($event.checked);
                    updateLdmAndMeasurement(package)
                  "
                  binary="true"
                >
                </p-checkbox>
              } @else {
                <i
                  class="pi pi-exclamation-triangle"
                  pTooltip="Stackability is taken into account for LDM calculation in one row only. (for example if you add 2 pieces and tick ‘Stackable’, LDMs will not change - but this rule applies to one row)
    Stackability will not be compared with pieces added in other rows."
                  tooltipPosition="left"
                  tooltipZIndex="10002"
                >
                </i>
              }
              <span class="package__option-label">Stackable</span>
            </div>
          </div>

          @if (!disabled()) {
            <button
              type="button"
              aria-label="Remove package"
              (click)="removePackage(i)"
              class="package__remove"
            >
              <i class="pi pi-trash"></i>
            </button>
          }
        </div>
      </div>
    }

    <div class="package__add-row">
      <button
        pButton
        severity="success"
        (click)="addPackage()"
        [disabled]="disabled()"
      >
        <i class="pi pi-plus"></i>
        Add package
      </button>
    </div>

    <div class="packages__totals-row">
      <p-selectbutton
        [options]="unitOptions"
        [ngModel]="selectedUnit"
        (onChange)="updateUnits($event.value)"
        optionLabel="label"
        size="small"
        optionValue="value"
      >
      </p-selectbutton>
      <div class="chip totals">
        Total: {{ getWeightSum() | currency }} {{ weightUnit }},
        {{ getMeasurementSum() | currency }} {{ cubicUnit }},
        @if (showLdm()) {
          {{ getTotalLdm() | currency }} LDM,
        }
        {{ getTotalQuantity() }} PCS
      </div>
    </div>

    <div class="packages__actions">
      <button
        pButton
        severity="primary"
        [outlined]="true"
        (click)="panel.hide()"
      >
        <i class="pi pi-times"></i>
        Cancel
      </button>
      <button
        pButton
        severity="primary"
        [disabled]="
          !areAllPackagesValid() ||
          !arePackagesModified() ||
          isLoading() ||
          disabled()
        "
        (click)="applyEmit(); panel.hide()"
      >
        <i class="pi pi-check"></i>
        Apply
      </button>
    </div>
  </div>
</p-popover>

<button
  pButton
  type="button"
  severity="success"
  class="packages-btn"
  (click)="togglePanel($event, panel)"
  data-cy="quote-packages"
>
  <i class="pi pi-box" aria-hidden="true"></i>
  {{ getButtonLabel() }}
</button>
